import type { NodeType, ResolvedPos } from "prosemirror-model";

import { triggerCharacter as baseTriggerCharacter } from "../../../vendor/prosemirror-suggestions";

import { isInBlock } from "./isInBlock";

export function triggerCharacter(
  char: string,
  { allowSpaces = false, disabledIn }: { allowSpaces?: boolean; disabledIn?: NodeType },
) {
  return ($position: ResolvedPos) => {
    if (disabledIn && isInBlock(disabledIn, $position)) {
      return;
    }

    return baseTriggerCharacter(char, { allowSpaces })($position);
  };
}
